const anonymous_suffix = "-au";
const anonymous_domain = "@anonymous.getunaty.com";

export function isAnonymousUnatyEmail(email="") {
    if(!email) {
        return false;
    }
    return email.endsWith(`${anonymous_suffix}${anonymous_domain}`);
}